import styled from '@emotion/styled/macro';
import { BaseButton, forTabletLandscapeDown, Sidebar, SidebarItem, Variables } from '@enter/core';
import { Icon } from '@mdi/react';
import { Collapse, CollapseProps } from '@mui/material';

export const LogoWrapper = styled.div`
    display: flex;
    height: ${Variables.topnavSize};
    padding: 20px 0 20px ${Variables.sidebarPadding};
    background-color: ${Variables.Colors.b300};

    ${forTabletLandscapeDown(`
        opacity: 0;
    `)};
`;

// FIXME:confirm z=index 2 for desktop
export const SideBar = styled(Sidebar)`
    /* margin-top: ${Variables.topnavSize}; */
`;

export const MessageCount = styled.span`
    display: inline-block;
    text-align: center;
    margin-left: 8px;
    padding: 0 4px;

    height: 18px;
    min-width: 18px;
    width: auto;
    border-radius: 18px;

    font-size: 13px;
    line-height: 18px;
    font-weight: 500;
    color: ${Variables.Colors.white};
    background-color: ${Variables.Colors.b300};
`;

export const SidebarCollapse = styled(Collapse)<CollapseProps>``;

export const CollapseSidebarItem = styled(SidebarItem)`
    margin: 0 0 12px 0;
`;

export const RestrictedSidebarItem = styled(SidebarItem)`
    font-style: italic;
`;

export const CollapseButton = styled(BaseButton)`
    width: 24px;
    height: 24px;
    min-width: 0;
    padding: 0;
    background-color: transparent;
    position: absolute;
    transform: translateX(-120%);
`;

export const CollapseIcon = styled(Icon)<{ open: boolean }>`
    fill: ${Variables.Colors.p75};
    transition: ${Variables.transition};
    transform: rotate(${(props): number => (props.open ? 90 : 0)}deg);
`;

export const CollapseIndent = styled.span`
    display: inline-block;
    width: 18px;
`;
